import colors from "@/constants/colors"
import gradients from "@/constants/gradients"

export const getBackground = (backgroundColor: string) => {
    switch (backgroundColor) {
        case colors.white:
            return 'bg-white dark:bg-secondary-800 border'
        case colors.lightGray:
            return 'bg-secondary-50 dark:bg-secondary-800 border'
        case colors.primaryBlue:
            return 'bg-primaryBlue text-white dark:bg-secondary-800'
        case gradients.midnight:
            return 'bg-midnight-gradient text-white'
        default:
            return null
    }
}